// export const formatBVNDate = (date: any) => {
//   

import { monthsArr } from "./constants";

//   let a = date.split("-");
//   let year = a[2];
//   if (year > 20) {
//     year = `19${year}`;
//   } else {
//     year = `20${year}`;
//   }

//   let month = a[1];
//   switch (month) {
//     case "January":
//       month = "01";
//       break;
//     case "February":
//       month = "02";
//       break;
//     case "March":
//       month = "03";
//       break;
//     case "April":
//       month = "04";
//       break;
//     case "May":
//       month = "05";
//       break;
//     case "June":
//       month = "06";
//       break;
//     case "July":
//       month = "07";
//       break;
//     case "August":
//       month = "08";
//       break;
//     case "September":
//       month = "09";
//       break;
//     case "October":
//       month = "10";
//       break;
//     case "November":
//       month = "11";
//       break;
//     case "December":
//       month = "12";
//       break;

//     default:
//     // code block
//   }
//   let formattedDate = `${year}-${month}-${a[0]}`;

//   return formattedDate;
// };

export const formatBVNDate = (date: string): string => {
  if (!date) return "";

  // Map to handle all valid month representations (case-insensitive)
  const monthMap: { [key: string]: string } = {
    jan: "01",
    january: "01",
    feb: "02",
    february: "02",
    mar: "03",
    march: "03",
    apr: "04",
    april: "04",
    may: "05",
    jun: "06",
    june: "06",
    jul: "07",
    july: "07",
    aug: "08",
    august: "08",
    sep: "09",
    sept: "09",
    september: "09",
    oct: "10",
    october: "10",
    nov: "11",
    november: "11",
    dec: "12",
    december: "12",
  };

  let [day, month, year] = date.split("-");

  // Convert year to four digits
  year =
    year.length === 2
      ? parseInt(year) > 20
        ? `19${year}`
        : `20${year}`
      : year;

  // Normalize month to lowercase and match against monthMap
  const formattedMonth =
    monthMap[month.toLowerCase()] || month.padStart(2, "0");

  if (!formattedMonth) {
    throw new Error(`Invalid month: ${month}`);
  }

  // Ensure day is two digits
  const formattedDay = day.padStart(2, "0");

  // Construct the formatted date in 'YYYY-MM-DD' format
  const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;


  return formattedDate;
};

export function convertDateOfBirthNIN(dateOfBirth) {
  // Split the input date string into [day, monthName, year]
  const [day, monthName, year] = dateOfBirth?.split("-");

  // Find the month number (1-12) from the month name
  const monthNumber = monthsArr.indexOf(monthName) + 1;

  // Format the month and day to be two digits (e.g., '04' for April, '05' for the 5th)
  const month = monthNumber.toString().padStart(2, "0");
  const formattedDay = day.padStart(2, "0");

  // Return the formatted date in 'YYYY-MM-DD' format
  return `${year}-${month}-${formattedDay}`;
}
